import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { unregister } from './registerServiceWorker'

const rootElement = document.getElementById('root')

// Use hydrate if pre-rendered by react-snap, otherwise use render
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate((
    <BrowserRouter>
      <App />
    </BrowserRouter>
  ), rootElement)
} else {
  ReactDOM.render((
    <BrowserRouter>
      <App />
    </BrowserRouter>
  ), rootElement)
}

// Unregister service worker to ensure fresh content is always served
// This is important for SEO and to avoid caching issues with pre-rendered pages
unregister()
